/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipe_Action_EditInputs */

const en_recipe_action_edit = /** @type {(inputs: Recipe_Action_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit`)
};

const de_recipe_action_edit = /** @type {(inputs: Recipe_Action_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bearbeiten`)
};

/**
* | output |
* | --- |
* | "Edit" |
*
* @param {Recipe_Action_EditInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_action_edit = /** @type {((inputs?: Recipe_Action_EditInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_Action_EditInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_action_edit(inputs)
	return en_recipe_action_edit(inputs)
});